export const stcTabsLinking = {
    screens: {
        STC_Home: {
            path: 'support-the-creators/*',
        },
    },
};
